import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const BackButton = ({ backUrl }: { backUrl?: string }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="btn secondary icon-link"
      onClick={(event) => {
        event.preventDefault();

        if (backUrl) {
          navigate(backUrl, { replace: true });
        } else {
          navigate(-1);
        }
      }}
    >
      <FontAwesomeIcon className="mr-2" icon={solid("arrow-left")} />
      <span>Tillbaka</span>
    </button>
  );
};

export default BackButton;
